
import Vue from 'vue'
import Toast from './Toast.vue'

export default Vue.extend({
   name: 'ToastContainer',
   data() {
      return {
         toasts: [] as IToast[],
         options: {
            position: 'top',
            alignment: 'center',
            duration: 5000,
         } as ToasterOptions,
      }
   },
   computed: {
      locationClass(): string {
         return `toast-${this.options.position}-${this.options.alignment}`
      },
   },
   methods: {
      error(message: string, title?: string, duration?: number) {
         this.queueMessage('error', message, title, duration)
      },
      warning(message: string, title?: string, duration?: number) {
         this.queueMessage('warning', message, title, duration)
      },
      info(message: string, title?: string, duration?: number) {
         this.queueMessage('info', message, title, duration)
      },
      success(message: string, title?: string, duration?: number) {
         this.queueMessage('success', message, title, duration)
      },
      setDefaults(options: ToasterOptions) {
         this.options = options
      },
      queueMessage(type: ToastType, message: string, title?: string, duration?: number) {
         const toast = {
            type,
            message,
            title,
         }
         const toastDuration = !!duration ? duration : this.options.duration
         this.toasts.push(toast)
         this.queueRemove(toast, toastDuration)
      },
      queueRemove(toast: IToast, duration: number) {
         setTimeout(() => {
            this.removeToast(toast)
         }, duration)
      },
      removeToast(toast: IToast) {
         const index = this.toasts.indexOf(toast)
         this.toasts.splice(index, 1)
      },
   },
   components: {
      Toast,
   },
})
